

import React,{useState, useEffect} from 'react';
import "../css/Profile.css";
import { useNavigate } from 'react-router-dom';
import PostDetail from './PostDetail';
import { useParams } from 'react-router-dom';
import { formatFollowerCount } from '../utils/formatFollowers';
import FollowersModal from './FollowersModal';
import FollowingModal from './FollowingModal';

export default function UserProfile() {
  var picLink = "https://cdn-icons-png.flaticon.com/128/1177/1177568.png"
  const {userid} = useParams();
  const navigate = useNavigate();
  const [isFollow, setIsFollow] = useState(false);
  const [user, setUser] = useState("");
  const [posts, setPosts] = useState([]);
  const [show, setShow] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);
  const [showFollowersModal, setShowFollowersModal] = useState(false);
  const [showFollowingModal, setShowFollowingModal] = useState(false);
  const [aboutExpanded, setAboutExpanded] = useState(false);
  const [showAboutModal, setShowAboutModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editAbout, setEditAbout] = useState("");
  const [editBio, setEditBio] = useState("");
  const [editAboutCount, setEditAboutCount] = useState(0);
  const [editBioCount, setEditBioCount] = useState(0);

  // to follow user
  const followUser = (userId) =>{
    fetch("/follow",{
      method:"put",
      headers:{
        "Content-Type":"application/json",
        Authorization: "Bearer " + localStorage.getItem("jwt")
      },
      body:JSON.stringify({ followId:userId })
    })
    .then(res=>res.json())
    .then(data => {
      console.log(data);
      setIsFollow(true);
    })
    .catch(err => console.error(err));
  }

  const unfollowUser = (userId) =>{
    fetch("/unfollow",{
      method:"put",
      headers:{
        "Content-Type":"application/json",
        Authorization: "Bearer " + localStorage.getItem("jwt")
      },
      body:JSON.stringify({ followId:userId })
    })
    .then(res=>res.json())
    .then(data => {
      console.log(data);
      setIsFollow(false);
    })
    .catch(err => console.error(err));
  }

  useEffect(() => {
    fetch(`/user/${userid}`,{
      headers:{
        Authorization: "Bearer " + localStorage.getItem("jwt")
      },
    })
        .then(res=>res.json())
        .then((result) => {
          console.log(result)
          setUser(result.user)
          setPosts(result.posts);
          setEditAbout(result.user.about || "");
          setEditBio(result.user.bio || "");
          if (
            result.user.followers.includes(
              JSON.parse(localStorage.getItem("user"))._id
            )
          ) {
            setIsFollow(true);
          }
        })
  }, [isFollow]);

  const formatBio = (bio) => {
    return { __html: bio ? bio.replace(/\n/g, '<br />') : '' };
  };

  const handleBack = () => {
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else {
      navigate('/search');
    }
  };

  const toggleDetails = (post) => {
    if (show) {
      setShow(false);
      setSelectedPost(null);
    } else {
      setShow(true);
      setSelectedPost(post);
    }
  };

  return (
    <div className='profile'>
      {/* Top navigation bar: back icon on left, options on right */}
      <div className="profile-top-nav">
        <button
          id="profileBackBtn"
          className="profile-back-btn"
          onClick={handleBack}
          aria-label="Back"
          title="Back"
        >
          <span className="material-symbols-outlined" style={{ fontSize: "28px" }}>arrow_back</span>
        </button>

        {JSON.parse(localStorage.getItem("user") || "null") && JSON.parse(localStorage.getItem("user"))._id === user._id ? (
          <button
            id="profileMoreBtn"
            className="profile-back-btn"
            onClick={() => navigate('/profile/options')}
            aria-label="Profile options"
            title="Options"
          >
            <span className="material-symbols-outlined" style={{ fontSize: "28px" }}>menu</span>
          </button>
        ) : (
          <button
            id="profileMoreBtn"
            className="profile-back-btn"
            onClick={() => navigate('/profile/home-post-options')}
            aria-label="User options"
            title="Options"
          >
            <span className="material-symbols-outlined" style={{ fontSize: "28px" }}>more_vert</span>
          </button>
        )}
      </div>

      {/* Profile-frame */}
      <div className="profile-frame">
        {/* profile-pic */}
        <div className="profile-pic">
        <img src={user.Photo ? user.Photo : picLink} alt="" />
        </div>
        {/* profile-data */}
        <div className="profile-data">
          <div className="profile-header">
            <h1 style={{"margin-top": "7px"}} className="username">{user.name}</h1>
            <div className="header-actions">
              {JSON.parse(localStorage.getItem("user") || "null") && JSON.parse(localStorage.getItem("user"))._id === user._id ? (
                <button id="editProfileBtn" onClick={() => setIsEdit(!isEdit)}>{isEdit ? 'Cancel' : 'Edit'}</button>
              ) : (
                <button className='followBtn'
              onClick={() => {
                if(isFollow){
                  unfollowUser(user._id)
                }else{
                  followUser(user._id)
                }
              }}>
                {isFollow ? "Unfollow" : "Follow"}
                </button>
              )}
            </div>
          </div>

          {isEdit ? (
            <div>
                <textarea id="editBioTextArea" value={editBio} onChange={(e) => { setEditBio(e.target.value); setEditBioCount(e.target.value.length); }} maxLength={130} style={{minHeight:80}} />
                <div style={{textAlign:'right',fontSize:12,color:'#666'}}>{editBioCount}/130</div>
                <textarea id="editAboutTextArea" value={editAbout} onChange={(e) => { setEditAbout(e.target.value); setEditAboutCount(e.target.value.length); }} maxLength={1000} style={{minHeight:120}} />
                <div style={{textAlign:'right',fontSize:12,color:'#666'}}>{editAboutCount}/1000</div>
              <div>
                <button id="editProfileSaveBtn" onClick={async () => {
                  // save changes
                  if (editBio && editBio.length > 130) { alert('Bio cannot exceed 130 chars'); return; }
                  if (editAbout && editAbout.length > 1000) { alert('About cannot exceed 1000 chars'); return; }
                  // validate interests as a character-limited field (max 120 chars, ~2 lines)
                  if (!user.interests || user.interests.trim().length === 0) { alert('Please add at least one interest'); return; }
                  if (user.interests.length > 80) { alert('Interests cannot exceed 80 characters'); return; }

                  try {
                    const res = await fetch(`/user/${user._id}`, {
                      method: 'PUT',
                      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + localStorage.getItem('jwt') },
                      body: JSON.stringify({ bio: editBio, about: editAbout, interests: user.interests })
                    });
                    const data = await res.json();
                    if (data.error) { alert(data.error); return; }
                    setUser(data.user);
                    setIsEdit(false);
                    // update local storage user copy if current user
                    try { const cur = JSON.parse(localStorage.getItem('user')); if (cur && cur._id === data.user._id) { localStorage.setItem('user', JSON.stringify(data.user)); } } catch(e){}
                  } catch (e) { console.error(e); alert('Save failed'); }
                }}>Save</button>
                <button id="editProfileCancleBtn" onClick={() => setIsEdit(false)}>Cancel</button>
              </div>
            </div>
          ) : (
            <p dangerouslySetInnerHTML={formatBio(user?.bio)}></p>
          )}
          {user?.about && (
            <div style={{marginTop:8}}>
              <button onClick={() => setShowAboutModal(true)} style={{padding:'6px 10px', "borderRadius":"12px", "background-color": "#494949", "color":"white", "font-weight": "bolder"}}>See About</button>
            </div>
          )}
          {showAboutModal && (
            <div style={{position:'fixed',left:0,top:0,right:0,bottom:0,background:'rgba(0,0,0,0.4)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:2000}} onClick={() => setShowAboutModal(false)}>
              <div onClick={(e)=>e.stopPropagation()} style={{background:'var(--surface)',color:'var(--text)',padding:20,borderRadius:8,maxWidth:'90%',maxHeight:'80%',overflowY:'auto'}}>
                <h3>About</h3>
                <div style={{whiteSpace:'pre-wrap',lineHeight:1.5}}>{user.about}</div>
                <div style={{textAlign:'right',marginTop:12}}>
                  <button onClick={() => setShowAboutModal(false)} style={{padding:'6px 10px',"borderRadius": "12px",color:'var(--text)', "background-color": "#830a0a"}}>Close</button>
                </div>
              </div>
            </div>
          )}
          <p>
            <strong style={{color:"yellow"}}>Interests:</strong>
            <br />
            <span style={{color: "white", textShadow: "0 0 10px blue, 0 0 20px blue, 0 0 40px blue"}}><b>{user?.interests}</b></span>
          </p>
          {/* <p><b>{user?.state}, {user?.country}</b></p> */}
          <div className="profile-stats">
            <div className="stat">
              <span className="stat-num">{posts ? posts.length : "0"}</span>
              <span className="stat-label">posts</span>
            </div>
            <div className="stat" style={{cursor:'pointer'}} onClick={() => setShowFollowersModal(true)}>
              <span className="stat-num">{formatFollowerCount(user.followers ? user.followers.length : 0)}</span>
              <span className="stat-label">followers</span>
            </div>
            <div className="stat" style={{cursor:'pointer'}} onClick={() => setShowFollowingModal(true)}>
              <span className="stat-num">{formatFollowerCount(user.following ? user.following.length : 0)}</span>
              <span className="stat-label">following</span>
            </div>
          </div>
        </div>
      </div>
      <hr style={{
        width:"90%",

        opacity: "0.8",
        margin:"25px auto"
      }} 
      />
      {/* Gallery */}
      <div className="gallery">
        {posts.map((pics) => {
          if (!pics) return null;
          const hasMedia = pics.media && pics.media.length > 0;
          let preview = null;
          if (hasMedia) {
            const m = pics.media[0];
            if (m.type === 'image') {
              preview = <img src={m.url} className='item thumbnail-img' alt="" onError={(e)=>{ /* nothing */ }} />;
            } else if (m.type === 'video') {
              if (m.thumbnail) {
                preview = (
                  <div style={{position:'relative', display:'inline-block'}}>
                    <img src={m.thumbnail} className='item thumbnail-img' alt="" onError={(e)=>{ if (m.url) e.currentTarget.src = m.url; }} />
                      <div style={{position:'absolute',right:8,bottom:8,zIndex:9999,pointerEvents:'none',width:32,height:32,display:'flex',alignItems:'center',justifyContent:'center',background:'rgba(0,0,0,0.6)',borderRadius:16}} aria-hidden="true">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                          <path d="M8 5v14l11-7L8 5z" fill="#fff" />
                        </svg>
                      </div>
                  </div>
                );
              } else {
                preview = (
                  <div style={{position:'relative', display:'inline-block'}}>
                    <video src={m.url} className='item' muted playsInline preload='metadata' style={{width:100,height:100,objectFit:'cover'}} />
                      <div className='thumbnail-overlay' style={{zIndex:2000, pointerEvents:'none'}}>▶</div>
                  </div>
                );
              }
            }
          } else if (pics.photo) {
            preview = <img src={pics.photo} className='item' alt="" />;
          }
          return (
            <div key={pics._id} style={{width:'33%', textAlign:'center', cursor:'pointer'}} onClick={() => toggleDetails(pics)}>
              {preview}
            </div>
          );
        })}
      </div>
      {show && selectedPost && (
        <PostDetail item={selectedPost} toggleDetails={toggleDetails} hideDelete={true} />
      )}
      {/* {show && 
        <PostDetail item={posts} toggleDetails={toggleDetails} />
      } */}

      {showFollowersModal && (
        <FollowersModal userId={userid} onClose={() => setShowFollowersModal(false)} />
      )}

      {showFollowingModal && (
        <FollowingModal userId={userid} onClose={() => setShowFollowingModal(false)} />
      )}
    </div>
  );
}

